module.exports = __webpack_public_path__ + "img/rightfilterwhite.770ecac9.svg";